export default "__VITE_ASSET__CR4tI3ag__"